import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import LanguageToggle from "./LanguageToggle";
import "../App.css";
import { FaShoppingCart } from "react-icons/fa";
import { isAdmin, clearAuth } from "../api/auth";
import { useLanguage } from "../i18n/LanguageContext";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const [theme, setTheme] = useState("light");
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  // Set initial theme
  useEffect(() => {
    const stored = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    const initialTheme = stored || (prefersDark ? "dark" : "light");
    setTheme(initialTheme);
    document.body.className = initialTheme;
  }, []);

  // Re-check admin login status on every navigation
  useEffect(() => {
    setIsAdminLoggedIn(isAdmin());
  }, [location]);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.body.className = newTheme;
  };

  const handleLoginLogout = () => {
    if (isAdminLoggedIn) {
      clearAuth();
      setIsAdminLoggedIn(false);
      navigate("/");
    } else {
      navigate("/admin/login");
    }
  };

  const isAdminRoute = location.pathname.startsWith("/admin") && isAdminLoggedIn;

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-logo">
          HoneyBuzz
        </Link>

        <div className="navbar-links">
          {!isAdminRoute ? (
            <Link to="/products">{t("nav.shop")}</Link>
          ) : (
            <>
              <Link to="/admin">{t("nav.dashboard")}</Link>
              <Link to="/admin/products">{t("nav.products")}</Link>
              <Link to="/admin/products/add">{t("nav.addProduct")}</Link>
              <Link to="/admin/orders">{t("nav.orders")}</Link>
            </>
          )}
        </div>
      </div>

      <div className="navbar-right">
        <LanguageToggle />
        <ThemeToggle theme={theme} toggleTheme={toggleTheme} />

        {!isAdminRoute && (
          <Link to="/cart" className="nav-icon-link" aria-label={t("nav.cart")}>
            <FaShoppingCart />
          </Link>
        )}

        <button onClick={handleLoginLogout} className="btn-signin">
          {isAdminLoggedIn ? t("nav.logout") : t("nav.login")}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
